export enum EmailStyleType {
  PRESET = 'preset',
  USER_PRESET = 'user_preset',
  CUSTOM = 'custom',
}
